import React, { useState, useMemo } from "react";
import { Grid, GridColumn as Column, GridNoRecords } from "@progress/kendo-react-grid";
import { ActiveCell, EditCommandCell, SignatureCell } from "../GridComponents";
import AddEditReferrer from "./AddEditReferrer";
import { Checkbox } from "@progress/kendo-react-inputs";
import { toast } from "react-toastify";
import { updateReferrer, useReferrers } from "services/referrersService";
import { GridLoader } from "components/GridLoader";

const ClientCell = (props) => (
  <td className="text-center align-middle">
    <div style={{ transform: "scale(1.3)", transformOrigin: "center" }}>
      <Checkbox checked={props.dataItem.forClients === true} readOnly />
    </div>
  </td>
);

const MatterCell = (props) => (
  <td className="text-center align-middle">
    <div style={{ transform: "scale(1.3)", transformOrigin: "center" }}>
      <Checkbox checked={props.dataItem.forMatters === true} readOnly />
    </div>
  </td>
);

const ReferrerList = () => {
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { data: referrerList, loading: isLoading } = useReferrers();

  const transformedData = useMemo(() => {
    if (!referrerList) return [];
    return referrerList.map((item) => ({
      ...item,
      forMatters: ["Matter", "Both"].includes(item.referrerType),
      forClients: ["Client", "Both"].includes(item.referrerType),
    }));
  }, [referrerList]);

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    setIsSubmitting(true);
    try {
      let type;
      if (event.forMatters && event.forClients) {
        type = "Both";
      } else if (event.forMatters) {
        type = "Matter";
      } else if (event.forClients) {
        type = "Client";
      } else {
        type = "Both";
      }

      const dataToPost = {
        ...event,
        referrerType: type,
      };
      const result = await updateReferrer(event.referrerID, dataToPost);
      if (result.success) {
        toast.success("Referrer updated successfully");
      }
      setOpenForm(false);
    } catch (error) {
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
    setEditItem(null);
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid container referrer-grid-wrapper h-100">
      <Grid data={transformedData} className="grid-minwidth-col2-200" style={{ height: "100%" }}
        showLoader={isLoading} loader={
          <div style={{ height: "50px" }}>
            <GridLoader />
          </div>
        }>
        <GridNoRecords>
          {isLoading ? (
            <span></span>
          ) : (
            transformedData && transformedData?.length === 0 && "No records available"
          )}
        </GridNoRecords>
        <Column
          field="referrerName"
          title=" "
          cell={SignatureCell}
          width="80"
        />
        <Column field="referrerName" title="Name" />
        <Column field="referrerDetails" title="Details" />
        <Column cell={ActiveCell} title="Active" field="active" width="80" />
        <Column
          cell={ClientCell}
          title="For Clients"
          field="forClients"
          width="120"
        />
        <Column
          cell={MatterCell}
          title="For Matters"
          field="forMatters"
          width="120"
        />
        <Column title=" " cell={MyEditCommandCell} width="60" />
      </Grid>

      {openForm && (
        <AddEditReferrer
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default ReferrerList;
